import { Link } from 'react-router-dom';

const features = [
  {
    id: 'comparador',
    title: 'Comparador de Cuotas en Directo',
    desc: 'Integración con las principales casas con licencia DGOJ. Ve en tiempo real dónde paga mejor tu apuesta.',
    icon: 'ri-scales-3-line',
    accent: '#00e87a',
    tag: 'TIEMPO REAL',
    link: '/comparador',
    image: 'https://readdy.ai/api/search-image?query=sports%20betting%20odds%20comparison%20dashboard%20screen%20showing%20multiple%20bookmaker%20prices%20in%20green%20and%20red%20numbers%20dark%20interface%20professional%20sports%20data%20analytics%20platform&width=600&height=360&seq=f1&orientation=landscape',
    size: 'large',
  },
  {
    id: 'ligas',
    title: 'Ligas Competitivas',
    desc: 'Compite con bankroll virtual y demuestra quién tiene el mejor ROI. Rankings automáticos en tiempo real.',
    icon: 'ri-trophy-line',
    accent: '#ffd700',
    tag: 'GAMIFICACIÓN',
    link: '/ligas',
    image: null,
    size: 'medium',
  },
  {
    id: 'alertas',
    title: 'Alertas Dropping Odds',
    desc: 'Notificaciones push y email automáticas cuando detectamos caídas bruscas de cuotas o lesiones de jugadores.',
    icon: 'ri-alarm-warning-line',
    accent: '#ff6b35',
    tag: 'ALERTAS',
    link: '/comparador',
    image: null,
    size: 'medium',
  },
  {
    id: 'buscador',
    title: 'Buscador de Tendencias',
    desc: 'Motor de filtros cruzados: "% partidos donde X equipo saca +5.5 córners en primera mitad siendo local".',
    icon: 'ri-search-eye-line',
    accent: '#a78bfa',
    tag: 'AVANZADO',
    link: '/estadisticas',
    image: null,
    size: 'medium',
  },
  {
    id: 'bankroll',
    title: 'Gestor de Bankroll',
    desc: 'Dashboard privado para registrar tus apuestas reales y visualizar tu rendimiento mensual con gráficas.',
    icon: 'ri-line-chart-line',
    accent: '#ff6b35',
    tag: 'PERSONAL',
    link: '/perfil',
    image: null,
    size: 'medium',
  },
  {
    id: 'tipsters',
    title: 'Ranking de Tipsters Verificado',
    desc: 'El ROI de cada tipster calculado automáticamente con resultados reales. Autoridad ganada, no comprada.',
    icon: 'ri-medal-line',
    accent: '#00e87a',
    tag: 'VERIFICADO',
    link: '/ranking',
    image: null,
    size: 'medium',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-24 bg-[#0d0f14]">
      <div className="max-w-[1440px] mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <p className="text-[#00e87a] text-xs font-bold tracking-widest uppercase mb-3">Todo lo que necesitas</p>
            <h2 className="text-white text-4xl md:text-5xl font-black uppercase leading-tight">
              PARA APOSTAR<br />
              <span className="text-white/50">INTELIGENTE</span>
            </h2>
          </div>
          <p className="text-[#a8b2c1] text-base max-w-sm leading-relaxed">
            Cada herramienta está diseñada para darte ventaja estadística sobre la casa y sobre el resto de apostadores.
          </p>
        </div>

        {/* Features grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Large feature card */}
          <Link
            to={features[0].link}
            className="md:col-span-1 md:row-span-2 bg-[#151719] border border-[#2a2d3a] rounded-2xl overflow-hidden group hover:border-[#00e87a]/40 transition-all duration-300 cursor-pointer"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src={features[0].image!}
                alt={features[0].title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#151719] to-transparent"></div>
            </div>
            <div className="p-6">
              <span className="inline-block px-3 py-1 rounded-full text-xs font-bold mb-4"
                style={{ background: `${features[0].accent}20`, color: features[0].accent }}>
                {features[0].tag}
              </span>
              <div className="w-10 h-10 flex items-center justify-center rounded-xl mb-3"
                style={{ background: `${features[0].accent}20`, color: features[0].accent }}>
                <i className={`${features[0].icon} text-xl`}></i>
              </div>
              <h3 className="text-white text-xl font-bold mb-3">{features[0].title}</h3>
              <p className="text-[#a8b2c1] text-sm leading-relaxed">{features[0].desc}</p>
              <div className="flex items-center gap-2 mt-5 text-sm font-semibold"
                style={{ color: features[0].accent }}>
                <span>Explorar</span>
                <div className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          </Link>

          {/* Medium feature cards */}
          {features.slice(1).map((f) => (
            <Link
              key={f.id}
              to={f.link}
              className="bg-[#151719] border border-[#2a2d3a] rounded-2xl p-6 group hover:border-white/20 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl"
                  style={{ background: `${f.accent}20`, color: f.accent }}>
                  <i className={`${f.icon} text-xl`}></i>
                </div>
                <span className="px-2.5 py-1 rounded-full text-xs font-bold"
                  style={{ background: `${f.accent}15`, color: f.accent }}>
                  {f.tag}
                </span>
              </div>
              <h3 className="text-white text-base font-bold mb-2">{f.title}</h3>
              <p className="text-[#6b7280] text-sm leading-relaxed">{f.desc}</p>
              <div className="flex items-center gap-1 mt-4 text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity"
                style={{ color: f.accent }}>
                <span>Ver más</span>
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
